module.exports = __webpack_public_path__ + "static/img/step-1.f5af3ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/tuto-unlock-popup/chrome/step-1.png
// module id = 950
// module chunks = 0